module.exports = __webpack_public_path__ + "static/media/photo_14.d42f5637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_14.jpg
// module id = 1647
// module chunks = 0